import { useState } from "react";
import { Check, ArrowRight } from "lucide-react";

export default function QuizView({ questions, title = "Sprawdzian wiedzy", onFinish }) {
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [answers, setAnswers] = useState([]);

  const q = questions[current];
  const total = questions.length;
  const progress = ((current) / total) * 100;

  const submit = () => {
    if (selected === null) return;
    const newAnswers = [...answers, selected];
    if (current + 1 >= total) {
      onFinish(newAnswers);
      return;
    }
    setAnswers(newAnswers);
    setSelected(null);
    setCurrent(current + 1);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="quiz-view">
      {/* Progress */}
      <div className="sticky top-0 bg-white/90 backdrop-blur border-b border-slate-100 z-10">
        <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-3">
          <div className="flex items-center justify-between text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">
            <span data-testid="quiz-progress-label">{title} · pytanie {current + 1} z {total}</span>
            <span>{Math.round(progress)}%</span>
          </div>
          <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden" data-testid="quiz-progress-bar">
            <div
              className="h-full bg-[#FFD600] transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      </div>

      <div className="flex-1 max-w-[900px] w-full mx-auto px-4 sm:px-6 py-8 sm:py-12 ss-fadein" key={current}>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-slate-900 leading-tight" data-testid="quiz-question">
          {q.question}
        </h2>

        <div className="mt-6 sm:mt-8 space-y-3">
          {q.options.map((opt, i) => {
            const isActive = selected === i;
            return (
              <button
                key={i}
                data-testid={`quiz-option-${i}`}
                onClick={() => setSelected(i)}
                className={`w-full text-left flex items-center gap-4 rounded-2xl border-2 px-5 py-4 transition-all ${
                  isActive
                    ? "border-[#FFD600] bg-[#FEF9C3] shadow-[0_6px_20px_-4px_rgba(255,214,0,0.35)]"
                    : "border-slate-200 hover:border-slate-400 bg-white"
                }`}
              >
                <span className={`w-8 h-8 rounded-xl flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  isActive ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600"
                }`}>
                  {String.fromCharCode(65 + i)}
                </span>
                <span className="text-slate-900 text-base sm:text-lg leading-snug">{opt}</span>
                {isActive && <Check className="w-5 h-5 text-slate-900 ml-auto flex-shrink-0" />}
              </button>
            );
          })}
        </div>
      </div>

      <div className="sticky bottom-0 border-t border-slate-100 bg-white">
        <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-4 flex justify-end">
          <button
            data-testid="quiz-next-button"
            onClick={submit}
            disabled={selected === null}
            className="inline-flex items-center gap-2 bg-[#FFD600] hover:bg-[#E6C200] disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed text-slate-900 font-bold px-6 py-3.5 rounded-2xl btn-yellow-glow disabled:shadow-none"
          >
            {current + 1 >= total ? "Zakończ" : "Dalej"}
            <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </div>
  );
}
